module.exports = __webpack_public_path__ + "a7441b71296416a4de1bd86af8528348.pdf";